import { Version } from '../../shared/version/version';

export class Device {
  private _version: Version;

  constructor(
    private _oid: number,
    private _applicationId: string,
    private _applicationVersion: string
  ) {
    this.version = this.generateVersion(this._applicationVersion);
  }

  private generateVersion(version: string): Version {
    const splitVersion: Array<string> = version
      .replace(/-dev.*/, '')
      .split('.');
    const major: number = Number(splitVersion[0]) || 0;
    const minor: number = Number(splitVersion[1]) || 0;
    let patch = 0;
    if (splitVersion.length > 3) {
      patch = Number(splitVersion[2]) || 0;
    }
    return new Version(major, minor, patch);
  }

  public get oid(): number {
    return this._oid;
  }

  public set oid(oid: number) {
    this._oid = oid;
  }

  public get applicationId(): string {
    return this._applicationId.toLowerCase();
  }

  public set applicationId(applicationId: string) {
    this._applicationId = applicationId.toLowerCase();
  }

  public get version(): Version {
    return this._version;
  }

  public set version(version: Version) {
    this._version = version;
  }
}
